module.exports = __webpack_public_path__ + "media/images/flags/1x1/kaz-eaa0f0600f95c7dfa3b43c4146ffed6d.svg";